import { makeAutoObservable } from 'mobx';

const YES_NO_HIDE_DELAY = 45000;

class ButtonsStore {
  constructor() {
    this.toiletButton = false;
    this.handUpButton = true;
    this.firstButton = null;
    this.secondButton = null;
    this.isTopicButtonsDisplayed = false;
    this.isGlobalTopicButtonEnabled = false;
    this.studentsTopicButtons = {};
    this.isYesNoButtonsDisplayed = false;
    this.yesNoButtonsStartedAt = null;
    this.yesNoButtonsTimerId = null;
    this.isCameraPressed = false;
    this.isAudioPressed = false;
    this.emojiPreloader = false;

    makeAutoObservable(this, {
      handUpButton: false,
    });
  }

  setFirstButton = (name, image) => {
    this.firstButton = { name, image };
  };

  setSecondButton = (name, image) => {
    this.secondButton = { name, image };
  };

  setToiletButton = value => {
    this.toiletButton = value;
  };

  displayTopicButtons = value => {
    this.isTopicButtonsDisplayed = value;
  };

  setGlobalTopicButtonState = value => {
    this.isGlobalTopicButtonEnabled = value;
  };

  setStudentsTopicButton = (peerId, value) => {
    const { ...studentsTopicButtons } = this.studentsTopicButtons;
    studentsTopicButtons[peerId] = value;
    this.studentsTopicButtons = studentsTopicButtons;
  };

  hideYesNoButtons = () => {
    this.isYesNoButtonsDisplayed = false;
    this.yesNoButtonsStartedAt = null;

    if (this.yesNoButtonsTimerId) {
      clearTimeout(this.yesNoButtonsTimerId);
      this.yesNoButtonsTimerId = null;
    }
  };

  displayYesNoButtons = value => {
    if (!value) {
      this.hideYesNoButtons();
      return;
    }

    if (this.yesNoButtonsTimerId) {
      clearTimeout(this.yesNoButtonsTimerId);
      this.yesNoButtonsTimerId = null;
    }

    this.isYesNoButtonsDisplayed = true;
    this.yesNoButtonsStartedAt = Date.now();

    this.yesNoButtonsTimerId = setTimeout(() => {
      this.hideYesNoButtons();
    }, YES_NO_HIDE_DELAY);
  };

  setIsCameraPressed = value => {
    this.isCameraPressed = value;
  };

  setIsAudioPressed = value => {
    this.isAudioPressed = value;
  };

  setEmojiPreloader = value => {
    this.emojiPreloader = value;
    const timerId = setTimeout(() => {
      this.setEmojiPreloader(false);
      clearTimeout(timerId);
    }, 5000);
  };
}

export default ButtonsStore;
